import packageListTemplate from './packageList.html';

const packageList = {
    bindings: {
        packages: '=',
        search: '=',
        showPurchased: '=',
        filterCriteria: '=?',
        itemCountAfterSearching: '=?',
    },
    template: packageListTemplate,
    controller: function ($element, $timeout, $state, $scope, $rootScope) {
        var self = this;
        this.$scope = $scope;
        this.$rootScope = $rootScope;

        window.addEventListener('resize', function (event) {
            self.scrollSlider();
        });

        this.$onInit = function () {
            this.itemCountAfterSearching = self.getPackageItemsCount();
            $timeout(function () {
                self.scrollSlider();
                let element = $rootScope.isMobileView
                    ? $element.find('div')[0]
                    : $element.find('div')[1];
                element.addEventListener('scroll', function (event) {
                    self.scrollSlider();
                });
            });
        };

        this.getPackageItemsCount = () => {
            if (!this.packages) return 0;
            return this.packages.length;
        };

        this.$scope.$on('searchPerformed', function (event) {
            $timeout(function () {
                self.scrollSlider();
            });
        });

        this.filter = (selection) => {
            let filterText = '';
            switch (this.filterCriteria) {
                case 'topseller':
                    filterText = selection.topseller;
                    break;
                case 'pension':
                    filterText =
                        selection.subtitle &&
                        selection.subtitle.includes('Pension') &&
                        !selection.subtitle.includes('Insurance');
                    break;
                case 'insurance':
                    filterText =
                        selection.subtitle &&
                        !selection.subtitle.includes('Pension') &&
                        selection.subtitle.includes('Insurance');
                    break;
                case 'pensionInsurance':
                    filterText =
                        selection.subtitle &&
                        selection.subtitle.includes('Pension') &&
                        selection.subtitle.includes('Insurance');
                    break;
                case 'other':
                    filterText =
                        selection.subtitle &&
                        !selection.subtitle.includes('Pension') &&
                        !selection.subtitle.includes('Insurance');
                    break;
                default:
                    filterText = true;
            }
            return filterText;
        };

        this.customSearch = (searchText) => {
            self.itemCountAfterSearching =
                searchText && searchText.length > 0
                    ? 0
                    : self.getPackageItemsCount();

            let lookInKeys = [
                'aumThreshold',
                'country',
                'investmentType',
                // "packagePosition",
                // "pricebookInfo",
                'productFamily',
                // "purchased",
                'region',
                // "selectionDescription",
                'selectionName',
                'subtitle',
                'totalNumberOfAccounts',
                'upToThreshold',
            ];

            return function (item) {
                if (!searchText) return true;
                for (var i = 0; i < lookInKeys.length; i++) {
                    var key = lookInKeys[i];
                    if (
                        ('' + item[key])
                            .toLowerCase()
                            .indexOf(('' + searchText).toLowerCase()) > -1
                    ) {
                        self.itemCountAfterSearching++;
                        return true;
                    }
                }
                return false;
            };
        };

        this.scrollSlider = (direction) => {
            let mySlideContainer = $rootScope.isWebView
                ? $element.find('div')[0]
                : $element.find('div')[1];
            let mySlideContainerPosition = mySlideContainer.scrollLeft;
            let mySlideContainerWidth = mySlideContainer.clientWidth;
            let mySlideContainerTotalWidth = mySlideContainer.scrollWidth;

            var arrowButtonLeft = $element[0].querySelector('.arrow-button');
            var arrowButtonRight = $element[0].querySelector(
                '.arrow-button--right'
            );

            if (direction === 'left') {
                mySlideContainer.scrollLeft -= 175;
            } else if (direction === 'right') {
                mySlideContainer.scrollLeft += 175;
            } else {
                mySlideContainerWidth = mySlideContainer.clientWidth;
            }

            if (mySlideContainerWidth === mySlideContainerTotalWidth) {
                arrowButtonLeft.style.visibility = 'hidden';
                arrowButtonRight.style.visibility = 'hidden';
            } else {
                arrowButtonLeft.style.visibility = 'visible';
                arrowButtonRight.style.visibility = 'visible';
            }

            if (mySlideContainer.scrollLeft == 0) {
                arrowButtonLeft.style.visibility = 'hidden';
            }

            if (
                mySlideContainerTotalWidth -
                    mySlideContainer.scrollLeft -
                    mySlideContainerWidth ==
                0
            ) {
                arrowButtonRight.style.visibility = 'hidden';
            }
        };

        this.getPackageUrl = (packageId) => {
            if (this.$rootScope.isMobileView) return null;
            if (this.showPurchased) {
                return $state.href(
                    'selectionPurchase',
                    { selectionId: packageId },
                    { reload: true }
                );
            } else {
                return $state.href(
                    'selectionDetail',
                    { selectionId: packageId },
                    { reload: true }
                );
            }
        };
    },
};

export default packageList;



/** WEBPACK FOOTER **
 ** ./src/app/directives/packageList/packageList.js
 **/